import React, { ComponentProps, PropsWithChildren } from "react";
import { ModalProps } from "react-bootstrap";

import "./BottomModal.scss";
import Overlay from "../Overlay/Overlay";

interface CustomModalBaseProps
  extends Pick<ModalProps, "show">,
    Omit<ComponentProps<"div">, "role" | "aria-modal"> {}

function CustomModalBase({
  children,
  show,
  className = "",
  ...restProps
}: PropsWithChildren<CustomModalBaseProps>) {
  if (!show) return null;

  return (
    <>
      <div
        role="dialog"
        aria-modal="true"
        className={`custom-modal-base MobileOnly ${className}`}
        {...restProps}
      >
        {children}
      </div>
      <Overlay />
    </>
  );
}

export default CustomModalBase;
